import { subscriptionManagerApiSlice } from "../apiSlice";

export const alarmSlice = subscriptionManagerApiSlice.injectEndpoints({
    endpoints: builder => ({
        postSubscribePeoAlarms: builder.mutation({
            query: ({buildingId, body}) => ({
                url: `/subscribe_peo_alarms/${buildingId}`,
                method: 'POST',
                body: JSON.stringify(body)
            }),
            invalidatesTags: ['AlarmSubscription']
        }),

        getSupportedAlarmJobTypes: builder.query({
            query:() =>{
                return {
                    url: `/subscribe_peo_alarms/supported_alarm_job_types`

                }
            },
            providesTags: ["SupportedAlarmJobTypes"]
        }),

        getSupportedPeoJobTypes: builder.query({
            query:() =>{
                return {
                    url: `/subscribe_peo_alarms/supported_peo_job_types`

                }
            },
            providesTags: ["SupportedPeoJobTypes"]
        }),
    })
})

export const {
    usePostSubscribePeoAlarmsMutation,
    useGetSupportedAlarmJobTypesQuery,
    useGetSupportedPeoJobTypesQuery

    } = alarmSlice